import type { MailboxInfo } from 'owa-client-types';
import type { TaskHubItemState } from '../utils/taskHubItemState';
import { getMostUrgentItemState } from './getMostUrgentItemState';
import { getSurfacedAsyncItems } from './getSurfacedAsyncItems';

/** Backlog summary used by the pane selector to render the Tasks pane badge. */
export interface TasksHubStatusSummary {
    /** Number of items surfaced in the Tasks pane across both sections. */
    count: number;
    /** The most urgent response type present, driving the badge color/icon. Undefined when empty. */
    mostUrgentState: TaskHubItemState | undefined;
}

/**
 * Summarizes the account's Tasks Hub backlog: how many items it holds and the single most urgent
 * response type among them. Shares `getSurfacedAsyncItems` with `getEntriesBySection` so the badge
 * count always matches the items the hub actually lists.
 */
export function getTasksHubStatusSummary(mailboxInfo: MailboxInfo): TasksHubStatusSummary {
    const items = getSurfacedAsyncItems(mailboxInfo);

    return {
        count: items.length,
        mostUrgentState: getMostUrgentItemState(items),
    };
}
